export const CONTACT_TYPE_CLAIMS_ATTORNEY = "claimsAttorney"
export const CONTACT_TYPE_OTHER = "other"
